import { getBrowserCookie } from './get-browser-cookie';
import { LocalStorageWorker } from './localstorage-worker';
import { sanitizeLocale } from './sanitize-locale';
export var getFullLocale = function (isFromCookie) {
    var baseFullLocale = isFromCookie
        ? getBrowserCookie('locale')
        : LocalStorageWorker.getItem('locale');
    var externalLocale = getBrowserCookie('external-locale');
    return sanitizeLocale(baseFullLocale || externalLocale || window.navigator.language).toLowerCase();
};
